import alerts from "constants/alerts";

// Field configuration for AccountHolder screen
export const FIELD_CONFIG = {
  street: {
    validation: { required: true },
    message: alerts?.incorrect_details
  },
  city: {
    validation: { required: true },
    message: alerts?.incorrect_details
  },
  state: {
    validation: { required: true },
    message: alerts?.incorrect_details
  },
  zip_code: {
    validation: { required: true, length: 5 },
    message: alerts?.incorrect_details
  },
  phoneList: {
    validation: { required: true },
    message: alerts?.minimum_one_medical_contact_required
  }
};

// Generate validation fields object from config
export const VALIDATION_FIELDS = Object.keys(FIELD_CONFIG).reduce((acc, key) => {
  acc[key] = false;
  return acc;
}, {});

